<div class="container">
  <div class="content-box">
    <ol class="breadcrumb">
      <li><a routerLink="../setup">{{ 'GLOBAL.CONFIG_ASSISTANT'|translate }}</a></li>
      <li class="active">{{ 'GLOBAL.INTEGRATIONS'|translate }}</li>
    </ol>
    <div class="row">
      <div class="col-xs-12">
        <h4>{{ 'INTEGRATIONS.TITLE'|translate }}</h4>
        <p [innerHtml]="'INTEGRATIONS.API_DOCUMENTATION_HELP'|translate"></p>
      </div>
    </div>
    <div class="row tabset-margin" *ngIf="!loading; else loadingSpinner">
      <div class="col-xs-12">
        <tabset #staticTabs>
          <tab [active]="selectedTab === 'webhooks'" (selectedTab)="selectedTab = 'webhooks'" heading="Webhooks">
            <ag-webhooks [companyId]="companyId"></ag-webhooks>
          </tab>
          <tab [active]="selectedTab === 'api-keys'" (selectedTab)="selectedTab = 'api-keys'"
            *ngIf="account?.is.admin" heading="API Keys">
            <ag-api-keys [companyId]="companyId"></ag-api-keys>
          </tab>
          <tab [active]="selectedTab === 'client-credentials'" (selectedTab)="selectedTab = 'client-credentials'"
            *ngIf="account?.is.admin" heading="Client Credentials">
            <ag-client-credentials [companyId]="companyId"></ag-client-credentials>
          </tab>
          <tab [active]="selectedTab === 'siloreal'" (selectedTab)="selectedTab = 'siloreal'"
            *ngIf="account?.is.admin" heading="{{ 'SILOREAL_CREDENTIALS.TAB_TITLE'|translate }}">
            <ag-siloreal-credentials [companyId]="companyId"></ag-siloreal-credentials>
          </tab>
          <tab [active]="selectedTab === 'torres'" (selectedTab)="selectedTab = 'torres'"
            *ngIf="account?.is.admin && (!environment.production || company?.id === 401)"
            heading="{{ 'TORRES_CREDENTIALS.TAB_TITLE'|translate }}">
            <ag-torres-credentials [companyId]="companyId"></ag-torres-credentials>
          </tab>
          <!-- STOP: el estado de las cookies de SSTA es GLOBAL de la plataforma
               (una sola sesión, login público sin credenciales por empresa), así
               que la solapa se muestra a cualquier admin y no se restringe por
               company. Deliberadamente NO se copia el gate de Torres, que lleva
               `company?.id === 401` adentro: 401 es Syngenta en dev, pero en
               prod es 2648, así que ese literal dejaría la solapa invisible en
               producción. -->
          <tab [active]="selectedTab === 'stop'" (selectedTab)="selectedTab = 'stop'"
            *ngIf="account?.is.admin"
            heading="{{ 'STOP_COOKIES.TAB_TITLE'|translate }}">
            <ag-stop-cookies [companyId]="companyId"></ag-stop-cookies>
          </tab>
        </tabset>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingSpinner>
  <div class="loading">
    <spinner message="{{ 'GLOBAL.LOADING'|translate }}"></spinner>
  </div>
</ng-template>